/**
 * Human-readable byte size, used by the subtitle view, editor sidebar and
 * CC modal so all three read the same.
 *
 * @param {number} bytes
 * @returns {string}
 */
export function formatFileSize(bytes) {
  // Subtitles are routinely under 1 kB, and rounding those to "0 kB" reads as
  // a bug rather than a size.
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} kB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default formatFileSize;
